import React, { forwardRef, useMemo } from 'react';
import clsx from 'clsx';
import { BaseButton } from '../base-button';
import { Icon } from '../../icon';
import styles from './styles.module.css';
/**
 * `<LinkButton />` —  упрощённая кнопка, используется для навигации, вывода ссылки
 *
 * @example ```tsx
 * <LinkButton href="https://leroymerlin.ru>LeroyMerlin</LinkButton>
 * ```
 */

export const LinkButton = /*#__PURE__*/forwardRef(function LinkButton({
  className = '',
  variant = 'normal',
  children,
  size = 'm',
  iconLeft,
  iconRight,
  invert = false,
  ...props
}, ref) {
  const classNames = useMemo(() => clsx(styles.linkButton, styles[variant], className, size && styles[size], invert && styles.invert), [size, variant, className, invert]);
  const iconSize = size ? iconSizesByButtonSize[size] : 0;
  return /*#__PURE__*/React.createElement(BaseButton, {
    ref: ref,
    className: classNames,
    ...props
  }, iconLeft && /*#__PURE__*/React.createElement(Icon, {
    size: iconSize,
    className: styles.iconLeft
  }, iconLeft), children, iconRight && /*#__PURE__*/React.createElement(Icon, {
    size: iconSize,
    className: styles.iconRight
  }, iconRight));
});
const iconSizesByButtonSize = {
  s: 20,
  m: 24
};